import apiClient from "./apiClient";

export const getInventoryCategories = (page = 1, limit = 30) => apiClient
    .get("/inventory-categories", { params: { page, limit } })
    .then(res => res);
export const getInventroyCategoryById = (id) => apiClient.get(`/inventory-categories/${id}`);
export const createInventoryCategory = (data) => apiClient.post("/inventory-categories", data);
export const updateInventoryCategory = (id, data) => apiClient.put(`/inventory-categories/${id}`, data);
export const deleteInventoryCategory = (id) => apiClient.delete(`/inventory-categories/${id}`);

export const getInventoryTransactionTypes = (page = 1, limit = 30, search = "") => apiClient
    .get("/inventory-transaction-types", { params: { page, limit, search } })
    .then(res => res);
export const getInventroyTransactionTypeById = (id) => apiClient.get(`/inventory-transaction-types/${id}`);
export const createInventoryTransactionType = (data) => apiClient.post("/inventory-transaction-types", data);
export const updateInventoryTransactionType = (id, data) => apiClient.put(`/inventory-transaction-types/${id}`, data);
export const deleteInventoryTransactionType = (id) => apiClient.delete(`/inventory-transaction-types/${id}`);

export const getInventorySuppliers = (page = 1, limit = 10, search="") => apiClient
    .get("/inventory-suppliers", { params: { page, limit, search } })
    .then(res => res);
export const getInventorySuppliersByOfficeId = (id) => apiClient.get(`/inventory-suppliers/office/${id}`);
export const getInventorySupplierById = (id) => apiClient.get(`/inventory-suppliers/${id}`);
export const createInventorySupplier = (data) => apiClient.post("/inventory-suppliers", data);
export const updateInventorySupplier = (id, data) => apiClient.put(`/inventory-suppliers/${id}`, data);
export const deleteInventorySupplier = (id) => apiClient.delete(`/inventory-suppliers/${id}`);

export const getInventoryItems = (page = 1, limit = 10, search="") => apiClient
    .get("/inventory-items", { params: { page, limit, search } })
    .then(res => res);
export const getLowStockInventoryItems = (page = 1, limit = 10, search="") => apiClient
    .get("/inventory-items/low-stock", { params: { page, limit, search } })
    .then(res => res);
export const getInventoryItemsByOfficeId = (id) => apiClient.get(`/inventory-items/office/${id}`);
export const getInventoryItemById = (id) => apiClient.get(`/inventory-items/${id}`);
export const createInventoryItem = (data) => apiClient.post("/inventory-items", data);
export const updateInventoryItem = (id, data) => apiClient.put(`/inventory-items/${id}`, data);
export const deleteInventoryItem = (id) => apiClient.delete(`/inventory-items/${id}`);

export const getInventoryTransactions = (page = 1, limit = 10, search="", sort = "date", order = "desc") => apiClient
    .get("/inventory-transactions", { params: { page, limit, search, sort, order } })
    .then(res => res);
export const getInventoryTransactionsByHistoryId = (id, page = 1, limit = 10, search="", sort = "date", order = "desc") => apiClient
    .get(`/inventory-transactions/history/${id}`, { params: { page, limit, search, sort, order } })
    .then(res => res);
export const getInventoryTransactionsByHistoryEntryId = (id, page = 1, limit = 10, search="", sort = "date", order = "desc") => apiClient
    .get(`/inventory-transactions/history-entry/${id}`, { params: { page, limit, search, sort, order } })
    .then(res => res);
export const getInventoryTransactionsByOfficeId = (id) => apiClient.get(`/inventory-transactions/office/${id}`);
export const getInventoryTransactionById = (id) => apiClient.get(`/inventory-transactions/${id}`);
export const createInventoryTransaction = (data) => apiClient.post("/inventory-transactions", data);
export const updateInventoryTransaction = (id, data) => apiClient.put(`/inventory-transactions/${id}`, data);
export const deleteInventoryTransaction = (id) => apiClient.delete(`/inventory-transactions/${id}`);

export const getBundles = (page = 1, limit = 10, search="") => apiClient
    .get("/bundles", { params: { page, limit, search } })
    .then(res => res);
export const getBundleById = (id) => apiClient.get(`/bundles/${id}`);
export const createBundle = (data) => apiClient.post("/bundles", data);
export const updateBundle = (id, data) => apiClient.put(`/bundles/${id}`, data);
export const deleteBundle = (id) => apiClient.delete(`/bundles/${id}`);

export const getBundleItems = (page = 1, limit = 10, search="") => apiClient
    .get("/bundle-items", { params: { page, limit, search } })
    .then(res => res);
export const getBundleItemById = (id) => apiClient.get(`/bundle-items/${id}`);
export const createBundleItem = (data) => apiClient.post("/bundle-items", data);
export const updateBundleItem = (id, data) => apiClient.put(`/bundle-items/${id}`, data);
export const deleteBundleItem = (id) => apiClient.delete(`/bundle-items/${id}`);